import { Route, Routes } from "react-router-dom";
import PageWrapper from "./components/layout/PageWrapper";
import { authRoutes } from "./menu";
import DatosFamiliares from "./pages/app/curriculum/DatosFamiliares";
import DatosPersonales from "./pages/app/curriculum/DatosPersonales";

const App = () =>{
  return (
    <Routes>
      <Route path="/*" element={<PageWrapper />} />
      {/* <Route path="/familiares" element={<DatosFamiliares />} />
      <Route path="/personales" element={<DatosPersonales />} /> */}
      {
        authRoutes.map(({path, element: Element}) => (
          <Route key={path} path={path} element={<Element />} />
        ))
      }
    </Routes>
  );
}

export default App;
